export * from './NewSlider';
